import { useParams, useNavigate } from "react-router-dom";
import { useWriterArticle, useUpdateArticle } from "@/hooks/useWriter";
import { ArticleEditor } from "@/components/writer/ArticleEditor";
import { Skeleton } from "@/components/ui/Skeleton";
import { useLocalDraft } from "@/hooks/useLocalDraft";

export function EditArticlePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const updateMutation = useUpdateArticle();
  const draftKey = id ? `x402-draft-${id}` : undefined;
  const draft = useLocalDraft(draftKey);

  const { data: article, isLoading } = useWriterArticle(id || "");

  if (isLoading) {
    return (
      <div className="max-w-5xl mx-auto px-4 py-10">
        <Skeleton className="h-8 w-48 mb-6" />
        <Skeleton className="h-96" />
      </div>
    );
  }

  if (!article) {
    return (
      <div className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h2 className="text-2xl font-display font-bold">Article not found</h2>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-2xl font-display font-bold mb-6">Edit Article</h1>
      <ArticleEditor
        initial={article}
        initialContent={article.contentMarkdown}
        draftKey={draftKey}
        onSubmit={(data) => {
          updateMutation.mutate(
            { id: article.id, ...data },
            {
              onSuccess: () => {
                draft.clear();
                navigate("/writer/articles");
              },
            },
          );
        }}
        loading={updateMutation.isPending}
      />
    </div>
  );
}
